import React from 'react';
import type { Opportunity } from '../../types';
import { formatApplicantCount, renderCompetitionStars } from '../../lib/opportunityUi';

export function CompetitionBadge({ opportunity }: { opportunity: Opportunity }) {
  const level = opportunity.competitionLevel ?? 3;
  const applicants = formatApplicantCount(opportunity.expectedApplicants);

  return (
    <div className="wfx-opp-competition glass-surface">
      <span className="wfx-opp-competition-label">Competition</span>
      <p className="wfx-opp-competition-stars" aria-label={`${opportunity.competitionLabel} competition`}>
        {renderCompetitionStars(level)} <strong>{opportunity.competitionLabel}</strong>
      </p>
      {applicants && (
        <p className="wfx-muted">{applicants} expected applicants</p>
      )}
    </div>
  );
}
